import React from "react";
import {Col, Row} from "react-bootstrap";
import fiveTipsForMoreEmailSecurity from "../assets/blog/5-tips-for-more-email-security.webp";
import dmarcMadeEasy from "../assets/blog/dmarc-made-easy.webp";
import brandIdentificationCard from "../assets/blog/brand-identification-card.webp";
import "./LatestBlogs.css";
import {useTranslation} from "react-i18next";
import appname from "../appname";
import {routes} from "../routes";
import {I18nService} from "../service/i18nService";

const LatestBlogs = () => {
    const {t, i18n} = useTranslation();
    const i18nService = new I18nService();
    const lang = i18nService.getLanguage();

    const link = (lang, routeName) => `${appname}/${lang}/${routes[routeName][lang]}`;
    const blogData = [
        {
            title: t("pages.home.latestBlog.1.title"),
            description: t("pages.home.latestBlog.1.description"),
            buttonLabel: t("pages.home.latestBlog.1.buttonLabel"),
            link: link(lang, "fiveTipsForEmailSecurity"),
            img: {
                source: fiveTipsForMoreEmailSecurity,
                alt: t("pages.home.latestBlog.1.alt")
            }
        },
        {
            title: t("pages.home.latestBlog.2.title"),
            description: t("pages.home.latestBlog.2.description"),
            buttonLabel: t("pages.home.latestBlog.2.buttonLabel"),
            link: link(lang, "dmarcMadeEasy"),
            img: {
                source: dmarcMadeEasy,
                alt: t("pages.home.latestBlog.2.alt")
            }
        },
        {
            title: t("pages.home.latestBlog.3.title"),
            description: t("pages.home.latestBlog.3.description"),
            buttonLabel: t("pages.home.latestBlog.3.buttonLabel"),
            link: link(lang, "whyBimiIsImportantForYourBrand"),
            img: {
                source: brandIdentificationCard,
                alt: t("pages.home.latestBlog.3.alt")
            }
        },
    ];

    return (
        <section className="container my-5" aria-labelledby="blog">
            <h2 id="blog" className="text-center mb-4 fw-bold">
                {t("pages.home.latestBlog.title")}
            </h2>
            <Row className="g-4">
                {blogData.map((blog, index) => (
                    <Col key={index} xs={12} sm={6} md={4}>
                        <article className="text-center bg-white p-4 blog-card h-100">
                            <div className="blog-card-inner mb-3">
                                <img
                                    src={blog.img.source}
                                    alt={blog.img.alt}
                                    className={"img-fluid rounded border-0"}
                                    loading={"lazy"}
                                />
                            </div>
                            <h3 className="h6 fw-bold">{blog.title}</h3>
                            <p className={"blog-card-inner-description"}>{blog.description}</p>
                            <a href={blog.link} className={"btn btn-outline-primary mt-2"}>
                                {blog.buttonLabel}
                            </a>
                        </article>
                    </Col>
                ))}
            </Row>
        </section>
    );
};

export default LatestBlogs;
